import { useEffect } from 'react';

import { isNativeMobile } from './nativeBridge';
import { releaseNativeLaunchScreen } from './nativeShell';

// Full-screen loaders carry this attribute so the native launch screen covers them
// instead of the app showing a second loading animation right after it.
const LAUNCH_BLOCKING_SELECTOR = '[data-launch-blocking]';

/** Releases the native launch screen once the first real content has painted. */
export function NativeLaunchScreenRelease() {
  useEffect(() => {
    if (!isNativeMobile()) return undefined;
    let frame = 0;
    let released = false;
    const observer = new MutationObserver(() => check());
    function check() {
      if (released || document.querySelector(LAUNCH_BLOCKING_SELECTOR)) return;
      cancelAnimationFrame(frame);
      // Two frames: the first schedules after layout, the second after that content paints.
      frame = requestAnimationFrame(() => {
        frame = requestAnimationFrame(() => {
          if (released || document.querySelector(LAUNCH_BLOCKING_SELECTOR)) return;
          released = true;
          observer.disconnect();
          releaseNativeLaunchScreen();
        });
      });
    }
    observer.observe(document.body, { childList: true, subtree: true });
    check();
    return () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
    };
  }, []);
  return null;
}
